<template>
    <div :class="$route.path==='/' || $route.path==='/home' ? 'bulletin-list-home' : 'bulletin-list-full'">
        <div class="bulletin-list-content page-wrapper">
            <div class="bulletin-list-title" v-if="$route.path==='/' || $route.path==='/home'">
                <div class="bulletin-list-title-word">
                    <label class="bulletin-list-title-chinese-label">{{ $t('News.bulletinBoard') }}</label><br/>
                    <label class="bulletin-list-title-english-label">Personal Information</label>
                </div>
                <div class="bulletin-list-title-buttom" @click="$router.push('/news/newsList')"><b-button>more >></b-button></div>
            </div>
            <div :class="$route.path==='/' || $route.path==='/home' ? 'bulletin-list-list' : 'none'">
              <div class="page-wrapper" v-for="news in newsList" :key="news.id">
                <BulletinCard :id="news.id" :title="news.title" :content="news.content" :date="news.valid_at" :titlePic="news.image"></BulletinCard>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import BulletinCard from '@/components/HomePage/BulletinCard'

const BulletinList = Vue.extend({
  name: 'BulletinList',
  props: {
    newsList: {
      type: Array,
      default: () => { return [{ '': '' }, { '': '' }, { '': '' }] }
    }
  },
  data: function () {
    return {
      imageSource: require('../../assets/HomePage/bulletinDefaultImage.png')
    }
  },
  components: {
    BulletinCard
  }
})
export default BulletinList
</script>

<style>
.bulletin-list-home {
    background-color: #1D8F87;
    width: 100%;
}
.bulletin-list-full {
    background-color: #FFFFFF;
    width: 100%;
}
.bulletin-list-content {
    margin-left: auto;
    margin-right: auto;
}
.bulletin-list-title-buttom {
    transform: translate(45%, -180%);
}
.bulletin-list-title-word {
    text-align: center;
    padding-top: 30px;
    padding-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
    color: #FFFFFF;
}
.bulletin-list-list {
    transform: translateY(-5%);
}
.bulletin-list-title-chinese-label {
  font-size: 34px;
}
.bulletin-list-title-english-label {
  font-size: 28px;
}
</style>
